import { render, staticRenderFns } from "./ProductsReportHead.vue?vue&type=template&id=06f65e12&scoped=true"
import script from "./ProductsReportHead.vue?vue&type=script&lang=js"
export * from "./ProductsReportHead.vue?vue&type=script&lang=js"
import style0 from "./ProductsReportHead.vue?vue&type=style&index=0&id=06f65e12&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f65e12",
  null
  
)

export default component.exports